import { Configuration, V1Api, V2Api, V4Api } from "@flare/flare_server_client";
import { posthogCorrelationMiddleware } from "./utils/posthogCorrelation";

const configuration = new Configuration({
  basePath: import.meta.env.VITE_SERVER_URL,
  credentials: "include",
  middleware: [posthogCorrelationMiddleware],
});

export const SERVER = {
  v1: new V1Api(configuration),
  v2: new V2Api(configuration),
  v4: new V4Api(configuration),
};
